
type Language = 'fa' | 'en';

interface FormatFileSizeOptions {
    lang?: Language;
    decimals?: number;
}

const UNITS = {
    en: ['B', 'KB', 'MB', 'GB', 'TB'],
    fa: ['بایت', 'کیلوبایت', 'مگابایت', 'گیگابایت', 'ترابایت'],
};

export function formatFileSize(
    bytes: number,
    options: FormatFileSizeOptions = {}
): string {
    const { lang = 'en', decimals = 1 } = options;

    if (!bytes || bytes <= 0) {
        return lang === 'fa' ? '۰ بایت' : '0 B';
    }

    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const value = bytes / Math.pow(k, i);

    const roundedValue = Number(value.toFixed(decimals));

    return `${roundedValue} ${UNITS[lang][i]}`;
}